import {
  SET_ACCOUNT,
  LOGOUT,
  CHECK_AUTHENTICATION,
  SET_ACCOUNT_LOADING,
  UPDATE_ACCOUNT,
  UPDATE_USER_SCHOOL,
  UPDATE_ROLE,
  CHANGE_EMAIL,
  CHANGE_AVATAR,
  CHANGE_NAME,
  MY_RT_IDENTITY,
  UPGRADE_USER,
  UPDATE_GOOGLE_INTEGRATION,
  UPDATE_ONBOARDING,
} from '../mutation-types';

import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
import accountService from 'services/account';
import googleClassroomService from 'services/googleClassroom/googleClassroomServices';

import { EventBus } from 'utils/event-bus';
import Vue from 'vue';
import {
  leavePusherChannel,
} from 'utils/realTimeEventHelpers';
// Account
export const setAccount = ({ commit }, account) => {
  commit(SET_ACCOUNT, account);
};

export const updateAccount = ({ commit }, fields) => {
  commit(UPDATE_ACCOUNT, fields);
};

export const updateUserSchool = ({ commit }, fields) => {
  commit(UPDATE_USER_SCHOOL, fields);
};

export const setAccountLoading = ({ commit }, status) => {
  commit(SET_ACCOUNT_LOADING, status);
};

export const updateRole = ({ commit }, { id, role }) => {
  // This localStorage code is here because of single sign on troubles
  // when user is signing up
  const referring_user_id = localStorage.getItem('referring_user_id') || null;
  localStorage.removeItem('referring_user_id');
  const invite_code = localStorage.getItem('register_invite_code') || null;
  localStorage.removeItem('register_invite_code');

  return accountService
    .updateUser(id, { role, referring_user_id, invite_code })
    .then((res) => {
      // If the user just registred through single sign on, we need the
      // school information in the state for the upgrade success modal
      if (invite_code) {
        localStorage.setItem(
          'schoolInfoPostUpgrade',
          JSON.stringify(res.data.school_info)
        );
        EventBus.$emit('open-upgrade-success-modal');
      }
      return commit(UPDATE_ROLE, res.data.role);
    })
    .catch(console.error);
};

export const changeEmail = ({ commit }, email) => {
  commit(CHANGE_EMAIL, email);
};

export const changeAvatar = ({ commit }, payload) => {
  commit(CHANGE_AVATAR, payload);
};

export const changeName = ({ commit }, name) => {
  commit(CHANGE_NAME, name);
};

// Auth
export const logout = ({ commit, getters }) => {
  leavePusherChannel(getters.getProfile.id);
  //leave Call
  EventBus.$emit('end-live-audio', false);
  localStorage.removeItem('google_access_token');
  commit(LOGOUT);
  commit('RESET_STATE');
};

export const checkAuthentication = ({ commit }) => {
  commit(CHECK_AUTHENTICATION);
};

export const updateRTIdentity = ({ commit }, identity) => {
  commit(MY_RT_IDENTITY, identity);
};

export const fetchSandboxIdentity = ({ commit }) => {
  commit(MY_RT_IDENTITY, {
    avatar_url:
      'http://img4.wikia.nocookie.net/__cb20150810173547/harrypotter/images/f/f9/PromoHP1_Minerva_McGonagall_2.jpg',
    id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    is_rt_anonymous: true,
    name: 'Professor McGonagall',
    roundtable_id: 'e7b41d42-b980-4ee2-aff4-b6dfea324ecf',
  });
};

export const myRTIdentity = ({ commit }, roundtableID) =>
  roundtableService.myRoundtableIdentity(roundtableID).then((identity) => {
    identity.roundtable_id = roundtableID;
    identity.id ? commit(MY_RT_IDENTITY, identity) : null;
    return identity;
  })
    .catch((e) => {
      console.error(e);
      EventBus.$emit('toast-msg', 'You are not a student in this roundTable');
      Vue.router.push({ name: 'dashboard' });
    });

export const upgradeUser = ({ commit }, isPaid) => {
  commit(UPGRADE_USER, isPaid);
};

export const updateOnboarding = ({ commit }, onboardingObj) => {
  commit(UPDATE_ONBOARDING, onboardingObj);
};

export const addActivityPasses = ({ commit }, number_of_passes) => {
  commit('ADD_ACTIVITY_PASSES', number_of_passes);
};

export const useActivityPass = ({ commit }, number_of_passes_to_decrease) => {
  if (number_of_passes_to_decrease) {
    commit('ADD_ACTIVITY_PASSES', number_of_passes_to_decrease);
    return;
  }
  commit('ADD_ACTIVITY_PASSES', -1);
};

export const pusherAuthentication = ({ commit }, payload) => {
  const { socket_id } = payload;
  commit('PUSHER_AUTHENTICATION', socket_id);
};

export const getClassroomToken = ({ commit }, payload) => {
  const { code, redirect_uri, email } = payload;
  const payload_1 = {
    code,
    redirect_uri,
    email
  };
  return googleClassroomService.generateGoogleClassroomTokens(payload_1).then(({ data }) => {

    const { google_integration } = data;
    commit(UPDATE_GOOGLE_INTEGRATION, google_integration);
    return data;
  });
};

export const disconnectClassroomIntegrationAccount = ({ commit }) => {
  return googleClassroomService.disconnectClassroomIntegrationAccount().then(({ data }) => {

    const google_integration = {};
    commit(UPDATE_GOOGLE_INTEGRATION, google_integration);
    return data;
  }).catch(console.error);
};

export const updateUserEmail = (_, payload) => {
  return accountService
    .updateUserEmail(payload.id, payload)
    .then((res) => {
      if (res && res.data) {
        return res.data;
      } else {
        this.emitToastError();
      }
    })
    .catch(console.error);
};


// WEBPACK FOOTER //
// ./src/app/store/actions/account.js